import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{ scale: number }>`
	font-size: 10px;
	width: 91em;
	height: 55.3em;
	background-color: #fff;
	border-radius: 2.4em;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props.scale});

	&.mobile {
		width: 34.3em;
		height: 61.1em;
	}
`;

export const Alignment = styled.div`
	transform: translateY(-5em);
	display: flex;
	flex-direction: column;
	gap: 1em;
`;

export const Head = styled.div<{ background: string }>`
	height: 17.6em;
	background-image: url(${(props) => props.background});
	background-size: cover;
	background-position: top;
	background-repeat: no-repeat;
`;

export const Avatar = styled.img`
	position: absolute;
	top: 4%;
	left: 50%;
	transform: translateX(-50%);
	width: 16.3em;
`;

export const Title = styled.img`
	position: absolute;
	top: 2%;
	left: 50%;
	transform: translateX(-50%);
	width: 17.9em;
`;

export const Footer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	text-align: center;
	width: 80%;
	margin: 0 auto;
`;

export const Note = styled.span`
	margin: 0;
	font-family: "Baloo";
	font-weight: 400;
	font-size: 1.6666em;
	line-height: 1em;
	color: #f2994a;
`;

export const Copy = styled.p`
	max-width: 590px;
	margin: 0;
	font-size: 1.2em;
	line-height: 1.25em;
`;

export const Button = styled(ThemeButton)`
	font-size: 2.1em;
	width: 14.09523em;
	margin: 0 auto;
	transform: translateY(-2em);
`;
